import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "../atoms/Button";
import useModal from "../../hooks/useModal";
import Modal from "../molecules/Modal";
import { RiStickyNoteAddFill } from "react-icons/ri";
import TableReuniones from "../organisms/clientes/empresas/reuniones/TableReuniones";
import ModalCreateReunion from "../organisms/clientes/empresas/reuniones/ModalCreateReunion";
import { GET_ENTERPRISE_BY_ID } from "../../api/apiEmpresas";
import { GET_MEETINGS_BY_ENTERPRISE } from "../../api/apiReuniones";
import { GET_ACCOUNTANTS, GET_ADMINS } from "../../api/apiAdmin";
import { useSession } from "../../context/SessionContext";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";
import MeetStatus from "../atoms/MeetStatus";
import useMeetingStatus from "../../hooks/useMeetingStatus";

const ReunionesTemplate = () => {
	const { id } = useParams();
	const { user } = useSession();
	const [loading, setLoading] = useState(false);
	const [empresa, setEmpresa] = useState();
	const [reuniones, setReuniones] = useState();
	const [accountants, setAccountants] = useState();
	const [admins, setAdmins] = useState();
	const { open, close, isOpen } = useModal();
	const { isActive } = useMeetingStatus(empresa?.id);

	const getData = useCallback(async () => {
		setLoading(true);
		try {
			try {
				const accountantsData = await GET_ACCOUNTANTS();
				setAccountants(accountantsData);
			} catch (accountantsError) {
				console.error(accountantsError);
			}
			try {
				const adminsData = await GET_ADMINS();
				setAdmins(adminsData);
			} catch (errorAdmins) {
				console.error(errorAdmins);
			}
			try {
				const meetingsData = await GET_MEETINGS_BY_ENTERPRISE(id);
				const sortedMeetings = meetingsData?.sort((a, b) => b.id - a.id);
				setReuniones(sortedMeetings);
			} catch (errorReuniones) {
				console.error(errorReuniones);
			}
			try {
				const enterpriseData = await GET_ENTERPRISE_BY_ID(id);
				setEmpresa(enterpriseData);
			} catch (enterpriseError) {
				console.error();
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}, [id]);

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<div className="w-full h-full space-y-2">
			<CardHeader>
				<Breadcrumb
					items={[
						{
							label: `${empresa?.name || "cargando..."}`,
							to: `/clientes/empresas/${id}`,
						},
						{ label: "REUNIONES", to: null },
					]}
				/>
				{user?.role === "Client" && isActive && empresa && (
					<MeetStatus meetingId={empresa?.id} nameEnterprice={empresa?.name} />
				)}
				{user?.role !== "Client" && (
					<Button
						text={<RiStickyNoteAddFill size={22} />}
						bgColor="green"
						onClick={open}
						width="w-10"
					/>
				)}
			</CardHeader>
			<TableReuniones
				data={reuniones}
				loading={loading}
				accountants={accountants}
				admins={admins}
				empresa={empresa}
			/>
			{isOpen && !loading && empresa && (
				<Modal
					title="Nueva reunión"
					onClose={close}
					width="w-full"
					heigth="h-full"
				>
					<ModalCreateReunion
						onClose={close}
						empresa={empresa}
						refetch={getData}
						accountants={accountants}
						admins={admins}
					/>
				</Modal>
			)}
		</div>
	);
};

export default ReunionesTemplate;
